.booktags {
    display: flex;
    flex-flow: row wrap;
    overflow: hidden;
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 0.8rem;

    :global(li) {
        background-color: transparent;
        border: none;
        border-radius: 0 0.2rem 0.2rem 0;
        box-shadow:
            rgb(177 183 190) -1px 2px 0 -1px inset,
            rgb(177 183 190) -1px -2px 0 -1px inset,
            rgb(177 184 190) -3px -1px 0 -2px inset,
            rgb(179 183 190) -3px 1px 0 -2px inset;
        display: inline-block;
        height: 1.5em;
        line-height: 1.5em;
        margin: 0.2em 0.2em 0.2em calc(0.75em + 1.41421px - 0.0828427rem);
        max-width: 100%;
        padding: 0 1em 0 0.5em;
        position: relative;
        white-space: nowrap;
        z-index: 0;
    }

    :global(li i) {
        display: inline-block;
        font-size: inherit;
        line-height: inherit;
        max-width: 100%;
        overflow: hidden;
        pointer-events: none;
        text-decoration: none;
        text-overflow: ellipsis;
        font-style: normal;
    }

    :global(li)::before {
        background-color: transparent;
        border-style: solid;
        border-image: initial;
        border-color: rgb(177 183 190) transparent transparent rgb(177 183 190);
        border-radius: 0.2rem 0 0;
        border-width: 1px 0 0 1px;
        box-sizing: border-box;
        content: "";
        display: block;
        height: calc(1.06066em);
        left: 0;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
        width: calc(1.06066em);
        z-index: -1;
    }

    :global(li)::after {
        background-color: transparent;
        border: 1px solid rgb(177 183 190);
        border-radius: 50%;
        content: "";
        display: block;
        font-size: inherit;
        height: calc(0.2em);
        left: 1px;
        position: absolute;
        top: 50%;
        transform: translate(-100%, -50%);
        width: calc(0.2em);
        z-index: 1;
    }
}
